var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "25%", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("p", { staticClass: "p1" }, [_vm._v("新增收货地址")]),
      _c("el-input", { attrs: { placeholder: "收货人姓名 (请使用真实姓名)" } }),
      _c("el-input", { attrs: { placeholder: "手机号码" } }),
      _c("el-input", { attrs: { placeholder: "所在地区" } }),
      _c("el-input", { attrs: { placeholder: "街道、小区门牌等详细地址" } }),
      _c(
        "div",
        { staticClass: "ridioBox" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.checked,
                callback: function ($$v) {
                  _vm.checked = $$v
                },
                expression: "checked",
              },
            },
            [_vm._v("设为默认地址")]
          ),
          _c("el-button", { staticClass: "btns", attrs: { type: "primary" } }, [
            _vm._v("新增收获地址"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "line" }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-pagination", {
            attrs: { background: "", layout: "prev, pager, next", total: 10 },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }